import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["afterIcon", "beforeIcon", "children", "color", "disabled", "fontSize", "fontWeight", "loading", "spacingSize"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.module.css';
import { Spinner } from '../../../loader';
import { getTypographyComponent } from '../../internal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Компонент кнопки-ссылки для действий внутри одной страницы, не должен затрагивать url.
 */
var ActionLinkComponent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var afterIcon = _ref.afterIcon,
    beforeIcon = _ref.beforeIcon,
    children = _ref.children,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'default' : _ref$color,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 'M' : _ref$fontSize,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 'normal' : _ref$fontWeight,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$spacingSize = _ref.spacingSize,
    spacingSize = _ref$spacingSize === void 0 ? 'XS' : _ref$spacingSize,
    rest = _objectWithoutProperties(_ref, _excluded);
  var className = clsx(styles['action-link'], styles["spacing-size-".concat(spacingSize)], styles["font-size-".concat(fontSize)], styles[color], _defineProperty(_defineProperty({}, styles['loading'], loading), styles['disabled'], disabled));
  var TypographyComponent = getTypographyComponent(fontSize, fontWeight);
  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    className: className
  }, rest), {}, {
    ref: ref,
    children: [loading && /*#__PURE__*/_jsx("div", {
      className: styles['spinner'],
      children: /*#__PURE__*/_jsx(Spinner, {
        size: 16,
        color: "current_color"
      })
    }), beforeIcon, /*#__PURE__*/_jsx("span", {
      className: styles['content'],
      children: children && /*#__PURE__*/_jsx(TypographyComponent, {
        as: "span",
        color: "current_color",
        children: children
      })
    }), afterIcon]
  }));
});
ActionLinkComponent.displayName = 'ActionLink';
export var ActionLink = /*#__PURE__*/React.memo(ActionLinkComponent);